import * as React from 'react';
import { useSelector } from 'react-redux';

import { LinkButton } from '@cian/ui-kit';

import { PikPlusCarousel } from '../PikPlusCarousel';

import { PikPlusCard } from '../../components/PikPlusCard';
import { PikPlusLayout } from '../../components/PikPlusLayout';
import { PikPlusSubway } from '../../components/PikPlusSubway';
import { PikPlusFeatureCard } from '../../components/PikPlusFeatureCard';

import { getPikPlus, getFilters } from '../../selectors';

export interface IPikPlusBlockProps {
  residentialComplexId: number;
}

export function PikPlusBlock({ residentialComplexId }: IPikPlusBlockProps) {
  const pikPlus = useSelector(getPikPlus(residentialComplexId));
  const { location } = useSelector(getFilters);

  if (!pikPlus) {
    return null;
  }

  return (
    <PikPlusLayout
      title={pikPlus.title}
      description={pikPlus.description}
      card={
        <PikPlusCard
          imageUrl={pikPlus.imageUrl}
          url={pikPlus.url}
          finishInfo={pikPlus.finishInfo}
          price={pikPlus.minPrice}
          label={pikPlus.promoLabel}
          subwayInfo={pikPlus.subway && <PikPlusSubway regionId={location} {...pikPlus.subway} />}
        />
      }
      carousel={
        <PikPlusCarousel>
          {pikPlus.equipmentOptions.map((item, index) => (
            <PikPlusFeatureCard title={item.title} imageUrl={item.imageUrl} key={index} />
          ))}
        </PikPlusCarousel>
      }
      link={
        <LinkButton size="M" fullWidth href={pikPlus.url} target="_blank">
          Посмотреть проект
        </LinkButton>
      }
    />
  );
}
